import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { fontWeights, variants } from 'theme/typography';

const theme = createTheme({
	palette: {
		background: {
			//default: '#d6e3cf',
		},
		primary: {
			main: '#36454F',
		},
		secondary: {
			main: '#19857b',
		},
		error: {
			main: red.A400,
		},
	},
	typography: {
		allVariants: {
			textTransform: 'none',
			color: 'black',
			lineHeight: 'initial',
		},
		fontFamily: ['AtAmiga', 'Inter', 'sans-serif'].join(','),
		...variants,
		...fontWeights,
	},
});

export default theme;
